<script setup lang="ts">
interface IProps {
  title: string
  subtitle?: string
  description?: string
  primaryButtonText?: string
  secondaryButtonText?: string
  listItem?: { iconClass?: string; text: string }[]
  big?: boolean
}

const props = defineProps<IProps>()
</script>

<template>
  <div class="header-main">
    <div class="header-container-top">
      <div v-if="$slots.image" class="image">
        <slot name="image" />
      </div>

      <div class="container-top-content">
        <div flex items-center gap-2>
          <slot name="subtitleIcon" />

          <p>
            {{ props?.subtitle }}
          </p>
        </div>

        <div class="text">
          <h5>
            {{ props?.title }}
          </h5>

          <p>
            {{ props?.description }}
          </p>
        </div>

        <div v-if="$slots.buttons" class="container-buttons">
          <slot name="buttons" />
        </div>

        <div v-if="$slots.gridButtons" class="grid-buttons">
          <slot name="gridButtons" />
        </div>
      </div>
    </div>

    <div v-if="$slots.contentBottom" class="container-bottom">
      <slot name="contentBottom" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.header-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0 28px 0 0;

  .header-container-top {
    width: 100%;
    max-width: 768px;
    display: flex;
    justify-content: space-between;
    padding: 24px 0;
    gap: 40px;

    .image {
      min-width: 260px;
      max-width: 260px;
      width: 260px;
    }

    .container-top-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 20px;

      .text {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      h5 {
        --at-apply: text-soft-black;
        font-family: 'Circular Std Bold';
        font-size: 22px;
        font-weight: 700;
        line-height: 120%;
        max-width: 440px;
        line-height: -0.905px;

        @media screen and (min-width: 769px) {
          font-size: 24px;
        }
      }

      p {
        --at-apply: text-bluish-darker;
        font-variant-numeric: lining-nums proportional-nums;
        font-feature-settings: 'cv09' on, 'cv01' on;
        font-family: 'Inter';
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 175%;
        max-width: 440px;
      }

      .container-buttons {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
    }
  }
}
.grid-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  max-width: 550px;
  padding: 10px 0;
  --at-apply: border-t-1 border-ligh-bluish;

  @media screen and (min-width: 769px) {
    gap: 0 20px;
  }
}

.container-bottom {
  width: 100%;
  max-width: 768px;
  display: flex;
  padding: 24px 0;
  --at-apply: border-t-1 border-ligh-bluish;
}
@media screen and (max-width: 768px) {
  .header-main {
    --at-apply: border-1 border-ligh-bluish;
    padding: 0 20px;
    border-radius: 10px;
    .header-container-top {
      max-width: unset;
    }
    .image {
      display: none;
    }
    .container-bottom {
      display: none;
    }
    .grid-buttons {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: flex-start;
      width: 100%;
      max-width: unset;
      padding: 0;
      border-top: none;
    }
  }
}
</style>
